import React, { useState, useEffect } from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import GroupService from '../../../../Services/UserGroup/GroupService';
import GroupSearchParams from '../../../../Contents/Administration/UserGroups/GroupSearchParams';

const ActiveGroupSelect = ({
  value = null,
  className = 'w-100 form-control form-control-sm',
  filterCleared = false,
  fieldName = 'defaultFieldname',
  onChange = () => {},
}) => {
  const [selectValues, setSelectValues] = useState([]);

  useEffect(() => {
    const groupSearchParams = new GroupSearchParams();
    groupSearchParams.IsActive = true;
    GroupService.GetAllItemsBySearching('Name', 'Asc', 1, 99_999, groupSearchParams, false)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.data
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .forEach((group) => {
            optValues.push({
              label: group.name,
              value: group.groupId,
              disabled: false,
            });
          });
        setSelectValues(optValues);
      })
      .catch(() => {
        setSelectValues([]);
        ErrorMessage.SetErrorMessage('AGS41');
      });
  }, []);

  return (
    <SelectFieldCheckbox
      value={value}
      className={className}
      fieldName={fieldName}
      onChange={onChange}
      filterCleared={filterCleared}
      selectValues={selectValues}
    />
  );
};

export default ActiveGroupSelect;
